import {
  EnumDispatchState
} from '../../../../api';
import { apiDispatchesGET, apiDispatchesGETById } from '../../../../api/Pioneer/endpoints/dispatches';
import { enumKeyToValue, enumValueToKey } from '../../../../helpers';
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../../helpers/serviceResponseHelper';
import i18n from '../../../../i18n';
import { ActionIcons, DataTableActionConfiguration, DatePeriod } from '../../../../model';
import { ServiceResponse } from '../../../../model/serviceResponse';
import { getActiveBalanceZone, getActiveCompany } from '../../../../redux';
import { comunicationsSendsListItemsMapper } from './comunicationSends.mapper';
import { DispatchModel } from './comunicationSends.model';

export const fetchSendsListItems = (datePeriod: DatePeriod): Promise<ServiceResponse<any>> => {
  return apiDispatchesGET(datePeriod, getActiveBalanceZone(), getActiveCompany())
    .then(res => {
      return createSuccessServiceResponse(comunicationsSendsListItemsMapper(res));
    })
    .catch(error => {
      return createErrorServiceResponse(error);
    });
};

export const checkDispatchesState = async (
  dispatchesIds: any,
  desiredStates: EnumDispatchState[]
): Promise<any> => {
  return await apiDispatchesGETById(dispatchesIds, desiredStates).then(response => {
    return comunicationsSendsListItemsMapper(response);
  });
};

//#region Dispatches global actions

export const filterApplicableActionsConfiguration = (
  item: DispatchModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = [];
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.WARNING: {
        if (
          enumKeyToValue(EnumDispatchState, item.state) ===
          enumKeyToValue(EnumDispatchState, EnumDispatchState.Error)
        ) {
          applicableActionsConfiguration.push(configuration);
        }
        break;
      }
      case ActionIcons.LOADING: {
        if (
          enumKeyToValue(EnumDispatchState, item.state) !==
          enumKeyToValue(EnumDispatchState, EnumDispatchState.Error) &&
          enumKeyToValue(EnumDispatchState, item.state) !==
          enumKeyToValue(EnumDispatchState, EnumDispatchState.Finalizado)
        ) {
          applicableActionsConfiguration.push(configuration);
        }
        break;
      }
    }
  });

  return applicableActionsConfiguration;
};

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getQuantityDisagreementAction(), getStateLoadingAction()];
};

const getQuantityDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.WARNING,
    tooltip: i18n.t('comunicationSends:dataTable.tooltips.warning')
  };
};

const getStateLoadingAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.LOADING,
    tooltip: i18n.t('comunicationSends:dataTable.tooltips.loading'),
    isLoading: true
  };
};

//#endregion
